import React, { useMemo } from 'react';
import appleIcon from '~/assets/icons/apple.svg';
import box3Icon from '~/assets/icons/box_3.svg';
import groupIcon from '~/assets/icons/group.svg';
import mailBoxIcon from '~/assets/icons/mail_box.svg';
import passengerIcon from '~/assets/icons/passenger.svg';
import pizzaIcon from '~/assets/icons/pizza.svg';
import plantIcon from '~/assets/icons/plant.svg';
import powerFixIcon from '~/assets/icons/power_fix.svg';
import stationIcon from '~/assets/icons/station.svg';
import { CurrencyIcon } from '~/components/collections';

import { useWalletIcon } from '~/hooks';
import {
	Currency,
	GameplayJobProgressIcon,
	IGameplayJobProgress,
	numWord,
} from '~/shared';
import {
	StyledContainer,
	StyledCountContainer,
	StyledMoneyContainer,
	StyledText,
} from './HeadInfoJobProgress.styled';

type CurrencyIcons = {
	[key in Currency]: string | null;
};

type ProgressIcons = {
	[key in GameplayJobProgressIcon]: string;
};

const progressIcons: ProgressIcons = {
	[GameplayJobProgressIcon.Plant]: plantIcon,
	[GameplayJobProgressIcon.Delivery]: box3Icon,
	[GameplayJobProgressIcon.Passenger]: passengerIcon,
	[GameplayJobProgressIcon.Station]: stationIcon,
	[GameplayJobProgressIcon.MailBox]: mailBoxIcon,
	[GameplayJobProgressIcon.PowerFix]: powerFixIcon,
	[GameplayJobProgressIcon.Apple]: appleIcon,
	[GameplayJobProgressIcon.Pizza]: pizzaIcon,
	[GameplayJobProgressIcon.Group]: groupIcon,
};

const HeadInfoJobProgress: React.FC<{
	$progress: IGameplayJobProgress | null;
}> = ({ $progress }) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const donateIcon = useWalletIcon(Currency.Donate, true);

	const currencyIcons: Partial<CurrencyIcons> = {
		[Currency.Ruble]: rubleIcon,
		[Currency.Donate]: donateIcon,
	};

	const [progressIcon, wordForm, currencyIcon] = useMemo(
		() =>
			$progress
				? [
						progressIcons[$progress.icon],
						numWord($progress.counter, $progress.counterWordForms),
						currencyIcons[$progress.currencyIcon],
				  ]
				: ['', '', ''],
		[$progress, currencyIcons],
	);

	return (
		<StyledContainer className={'progress'}>
			<StyledCountContainer className={'count'}>
				<img src={progressIcon} className={'invert'} />
				<div className={'line'} />
				<StyledText>{`${$progress?.counter ?? 0} ${wordForm}`}</StyledText>
			</StyledCountContainer>
			<StyledMoneyContainer className={'money'}>
				<CurrencyIcon
					icon={currencyIcon || rubleIcon}
					size="md"
					className={
						$progress?.currencyIcon === Currency.Ruble ? 'invert' : 'noinvert'
					}
				/>
				<div className={'line'} />
				<StyledText>
					{$progress?.currencyAmount?.toLocaleString('ru-RU') ?? 0}
				</StyledText>
			</StyledMoneyContainer>
		</StyledContainer>
	);
};

export { HeadInfoJobProgress };
